export default (props, traits) => {
  const { colors, rhythm } = traits

  return {
    grid: {
      minHeight: rhythm(10)
    },

    nav: {
      height: '100%',
      borderRight: `thin solid ${colors.shade}`,

      '& li': {
        borderBottom: `thin solid ${colors.shade}`
      },

      '& button': {
        display: 'block',
        width: '100%',
        padding: rhythm(0.5)
      }
    },

    current: {
      backgroundColor: colors.primary,
      color: colors.light
    }
  }
}
